import styled from "@emotion/styled";

import { Loading, LoadingContainer } from "../../common";
import { Icon } from "../../icons";

const FieldBusyContainer = styled.div`
  ${LoadingContainer} {
    width: initial;
    margin-right: 12px;
  }
`;

export const PendingIcon = () => (
  <FieldBusyContainer>
    <Loading size={16} />
  </FieldBusyContainer>
);

export const ErrorIcon = () => <Icon icon="exclamation-circle" />;
